/* @flow */
import React from 'react';
import Relay from 'react-relay';
import { FormattedMessage } from 'react-intl';

import { connect } from 'react-redux';

import { css } from 'glamor';

import { openSearch, openMobileNavigation } from 'depop/state/navigation';

import FillHorizontal from 'depop/components/layout/FillHorizontal';

import ShopLink from 'depop/apps/shops/links/ShopLink';

import Logo from 'depop/components/Logo';
import MobileHeaderItem from './MobileHeaderItem';
import Link from 'depop/components/Link';

class MobileHeader extends React.Component {

  scrollToTop () {
    return window.scrollTo(0, 0);
  }

  render() {
    const { user, openSearch, openMobileNavigation } = this.props;
    const scrollToTop = this.scrollToTop;

    return (
      <nav
        {...css({
          zIndex: 10,
        })}>
        <div>
          <MobileHeaderItem>
            <a onClick={openMobileNavigation}>
              <FormattedMessage
                id="app.menuLabel"
                description="Menu Label"
                defaultMessage="Menu"
              />
            </a>
          </MobileHeaderItem>

          <div
            {...css({
              flexGrow: '0',
              flexShrink: '0',
              width: '90px',
              display: 'inline-block',
              position: 'absolute',
              left: '50%',
              marginLeft: '-45px'
            })}>
            <Link
              to={{ pathname: '/' }}
              onClick={scrollToTop}
              {...css({ display: 'block', verticalAlign: 'bottom' })}>
              <Logo />
            </Link>
          </div>

          <MobileHeaderItem float="right">
            <a onClick={openSearch}>
              <FormattedMessage
                id="app.searchLabel"
                description="Search Label"
                defaultMessage="Search"
              />
            </a>
          </MobileHeaderItem>
        </div>
      </nav>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openMobileNavigation: () => dispatch(openMobileNavigation()),
    openSearch: () => dispatch(openSearch()),
  };
};

const connected = connect(null, mapDispatchToProps);

export default Relay.createContainer(connected(MobileHeader), {
  fragments: {
    user: () => Relay.QL`
      fragment on User {
        ${ShopLink.getFragment('user')}
        id
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/MobileHeader.js